// extracted by mini-css-extract-plugin
module.exports = {"root":"TextInput_root__1NQr3","focused":"TextInput_focused__3eTnR","input":"TextInput_input__15is5"};